import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "hideIcon", "use", "useBreezeStyles"];
import UIButton from 'UIComponents/button/UIButton';
import { Flex } from 'foundations-components/components/Flex';
import { BREEZE_SPECIAL } from '../../../constants/BreezeUse';
import { getStyledCopilotButton } from './styledButtons/StyledCopilotBaseButton';
import styled from 'styled-components';
import { BreezeSingleStarIcon } from 'foundations-assets/icons/components/BreezeSingleStarIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledSpan = styled.span.withConfig({
  displayName: "CopilotBaseButton__StyledSpan",
  componentId: "sc-199x7pj-0"
})(["font-size:1.2em;"]);
export function CopilotBaseButton(_ref) {
  let {
      children,
      hideIcon = false,
      use = 'tertiary-light',
      // default to tertiary-light
      useBreezeStyles
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const useOverride = use === BREEZE_SPECIAL ? undefined : use;

  /** We want to allow a way for teams to still use non Breeze styling
   * This is a valid design use case where a button grouping the Breeze button will be
   * styled like the other buttons in the group
   */
  if (!useBreezeStyles) {
    return /*#__PURE__*/_jsx(UIButton, Object.assign({}, uiButtonProps, {
      use: useOverride,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "100",
        children: [!hideIcon && /*#__PURE__*/_jsx(StyledSpan, {
          className: "ai-icon",
          children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
        }), children]
      })
    }));
  }
  const CopilotButtonComponent = getStyledCopilotButton(use);
  return /*#__PURE__*/_jsx(CopilotButtonComponent, Object.assign({}, uiButtonProps, {
    use: useOverride,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "100",
      children: [!hideIcon && /*#__PURE__*/_jsx(StyledSpan, {
        className: "ai-icon",
        children: /*#__PURE__*/_jsx(BreezeSingleStarIcon, {})
      }), children]
    })
  }));
}